// Account APIs params
export enum ECustomerType {
  INDIVIDUAL = 1,
  CORPORATE = 3
}

export interface IResetPasswordParams {
  email: string;
}

export interface IRegisterParams {
  customerType: ECustomerType;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  mobileNumber: string;
  title: string;
  password: string;
  isdcode?: string;
}

// Account APIs responses
export interface ICountryAndDialCode {
  country: string;
  dialCode: string;
  countryCode: string;
}

export interface ICountryStoneinnoDetail {
  country: string;
  dialCode: string;
  id: number;
  countryCode: string;
}

export interface IDemoAccountCreationParams {
  name: string;
  email: string;
  phoneNumber: string;
  depositAmount?: number;
}

export interface IDemoAccountCreationResponse {
  login: number;
  name: string;
  email: string;
  investorPassword: string;
  password: string;
  userGroup: string;
  deposit: number;
  leverage: number;
  currency: string;
  serverName: string;
  phoneNumber: string;
}

export interface IPasswordUrlResponse {
  url: string;
}
